export interface IDiscountCode {
  id: number
  name: string
  code: string
  isActive: boolean
  description: string
  startDate: Date
  endDate: Date
  source: ISourceModel
  terms: string
  image: string
  discountCodeType: string
  branchIds: string[]
  discountLineItems: IDiscountLineItem[]
}

export type ISourceModel = {
  sourceID: number
  active: boolean
  class: string
  code: string
  description: string
}

export type IDiscountLineItem = {
  amount: number
  amountType: ReferralAmountTypes
  referralType: ReferralTypes
  services: IDiscountLineItemService[]
}

export type IDiscountLineItemService = {
  discountLineItemID: number
  discountLineItemServiceID: number
  serviceClass: string
  serviceCode: string
}

export enum ReferralAmountTypes {
  Flat,
  Percent,
}

export enum ReferralTypes {
  New,
  Existing,
}

export enum ServiceTypes {
  Service,
  ServiceClass,
}
